import util from "./_util";

const { request } = util;

const qnyUrl = "http://img.wish.hebyun.com.cn/";

const dealImage = (base64, w, callback) => {
  var newImage = new Image();
  var quality = 0.6; //压缩系数0-1之间
  newImage.src = base64;
  newImage.setAttribute("crossOrigin", "Anonymous"); //url为外域时需要
  var imgWidth, imgHeight;
  newImage.onload = function() {
    imgWidth = this.width;
    imgHeight = this.height;
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    if (Math.max(imgWidth, imgHeight) > w) {
      if (imgWidth > imgHeight) {
        canvas.width = w;
        canvas.height = (w * imgHeight) / imgWidth;
      } else {
        canvas.height = w;
        canvas.width = (w * imgWidth) / imgHeight;
      }
    } else {
      canvas.width = imgWidth;
      canvas.height = imgHeight;
      quality = 0.6;
    }
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
    var base64 = canvas.toDataURL("image/jpeg", quality); //压缩语句

    // 如想确保图片压缩到自己想要的尺寸,如要求在50-150kb之间，请加以下语句，quality初始值根据情况自定
    // while (base64.length / 1024 > 150) {
    // 	quality -= 0.01;
    // 	base64 = canvas.toDataURL("image/jpeg", quality);
    // }
    // 防止最后一次压缩低于最低尺寸，只要quality递减合理，无需考虑
    // while (base64.length / 1024 < 50) {
    // 	quality += 0.001;
    // 	base64 = canvas.toDataURL("image/jpeg", quality);
    // }
    // console.log("1354", base64);
    callback(base64); //必须通过回调函数返回，否则无法及时拿到该值
  };
};
export default {
  // 获取七牛云token
  GetToken() {
    return request.get("/basic/get_qiniutoken");
  },
  //   上传文件
  uploadFile(fileList, token) {
    let fileType = fileList instanceof Array;
    let url = "http://upload-z1.qiniup.com/putb64/-1"; //获得七牛上传图片的地址和token

    if (fileType == false) {
      return new Promise((resolve) => {
        let Base64 = fileList;
        dealImage(Base64, 800, (base64) => {
          let xhr = new XMLHttpRequest();
          xhr.open("POST", url, true);
          xhr.setRequestHeader("Content-Type", "application/octet-stream");
          xhr.setRequestHeader("Authorization", "UpToken " + token);
          xhr.send(base64.split(";base64,")[1]);
          xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
              let responseText = JSON.parse(xhr.responseText); // eslint-disable-line no-unused-vars
              // 上传图片的路径
              resolve([qnyUrl + responseText.hash]);
            }
          };
        });
      });
    } else {
    // 多张
      return new Promise((resolve) => {
        
        var fileUrlList = [];

        fileList.forEach((item) => {
          let Base64 = item.content;
          dealImage(Base64, 800, (base64) => {
            var xhr = new XMLHttpRequest();
            xhr.open("POST", url, true);
            xhr.setRequestHeader("Content-Type", "application/octet-stream");
            xhr.setRequestHeader("Authorization", "UpToken " + token);
            xhr.send(base64.split(";base64,")[1]);
            xhr.onreadystatechange = function () {
              if (xhr.readyState == 4) {
                let responseText = JSON.parse(xhr.responseText); // eslint-disable-line no-unused-vars
                // 上传图片的路径
                fileUrlList.push(qnyUrl + responseText.hash);
                if (fileUrlList.length == fileList.length) {
                  resolve(fileUrlList);
                } else {
                  console.log("上传中");
                }
              }
            };
          });
        });
      });
    }
  },

  // 查询地区
  queryRegion(data) {
    return request.get("/basic/get_region", data);
  },
  // 查询地区-级联返回
  queryLevelRegion(data) {
    return request.get("/basic/get_region_forddl", data);
  },
};
